var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPurchesorder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 418.318,
    height: 469.45,
    viewBox: "0 0 418.318 469.45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "purchesorder",
    transform: "translate(-40.841)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Background_Complete",
    "data-name": "Background Complete"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7489",
    "data-name": "Group 7489"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5559",
    "data-name": "Path 5559",
    d: "M323.685,380.081H451.792l4.121-81.288H319.564Z",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7486",
    "data-name": "Group 7486"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5560",
    "data-name": "Path 5560",
    d: "M328.555,308.283H443.682L441.934,335.5H330.053Z",
    fill: "none",
    stroke: "#dbdbdb",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5561",
    "data-name": "Path 5561",
    d: "M332.082,343.5l1.218,24.474H440.4l1.529-24.474Z",
    fill: "none",
    stroke: "#dbdbdb",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5562",
    "data-name": "Path 5562",
    d: "M398.527,324.453H375.489l-.749-5.806h24.536Z",
    fill: "none",
    stroke: "#dbdbdb",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5563",
    "data-name": "Path 5563",
    d: "M398.527,358.635H375.489l-.749-5.806h24.536Z",
    fill: "none",
    stroke: "#dbdbdb",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7487",
    "data-name": "Group 7487"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5564",
    "data-name": "Path 5564",
    d: "M341.451,380.081l-1.244,8.856-2.5,17.794h-4.892V380.081Z",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5565",
    "data-name": "Path 5565",
    d: "M341.451,380.081l-1.244,8.856h-7.395v-8.856Z",
    fill: "#dbdbdb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7488",
    "data-name": "Group 7488"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5566",
    "data-name": "Path 5566",
    d: "M434.026,380.081l1.244,8.856,2.5,17.794h4.892V380.081Z",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5567",
    "data-name": "Path 5567",
    d: "M434.026,380.081l1.244,8.856h7.395v-8.856Z",
    fill: "#dbdbdb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7490",
    "data-name": "Group 7490"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_378",
    "data-name": "Rectangle 378",
    width: 26.481,
    height: 11.19,
    transform: "translate(56.113 315.866)",
    fill: "none",
    stroke: "#ebebeb",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_379",
    "data-name": "Rectangle 379",
    width: 26.481,
    height: 11.19,
    transform: "translate(41.341 329.975)",
    fill: "none",
    stroke: "#ebebeb",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_380",
    "data-name": "Rectangle 380",
    width: 26.481,
    height: 11.19,
    transform: "translate(380.022 191.303)",
    fill: "none",
    stroke: "#ebebeb",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_381",
    "data-name": "Rectangle 381",
    width: 26.481,
    height: 11.19,
    transform: "translate(365.25 205.412)",
    fill: "none",
    stroke: "#ebebeb",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_382",
    "data-name": "Rectangle 382",
    width: 26.481,
    height: 11.19,
    transform: "translate(350.537 191.303)",
    fill: "none",
    stroke: "#ebebeb",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_383",
    "data-name": "Rectangle 383",
    width: 26.481,
    height: 11.19,
    transform: "translate(432.178 329.975)",
    fill: "none",
    stroke: "#ebebeb",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_384",
    "data-name": "Rectangle 384",
    width: 26.481,
    height: 11.19,
    transform: "translate(417.407 56.296)",
    fill: "none",
    stroke: "#ebebeb",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_385",
    "data-name": "Rectangle 385",
    width: 26.481,
    height: 11.19,
    transform: "translate(432.178 70.406)",
    fill: "none",
    stroke: "#ebebeb",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_386",
    "data-name": "Rectangle 386",
    width: 26.481,
    height: 11.19,
    transform: "translate(56.113 56.296)",
    fill: "none",
    stroke: "#ebebeb",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7497",
    "data-name": "Group 7497"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7492",
    "data-name": "Group 7492"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_387",
    "data-name": "Rectangle 387",
    width: 1.202,
    height: 114.236,
    transform: "translate(66.956 0)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7491",
    "data-name": "Group 7491"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_388",
    "data-name": "Rectangle 388",
    width: 6.681,
    height: 4.517,
    transform: "translate(64.216 108.88)",
    fill: "#dbdbdb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_389",
    "data-name": "Rectangle 389",
    width: 6.681,
    height: 3.015,
    transform: "translate(64.216 110.382)",
    fill: "#c7c7c7"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5568",
    "data-name": "Path 5568",
    d: "M62.411,143.293a5.143,5.143,0,1,0,5.143-5.143A5.143,5.143,0,0,0,62.411,143.293Z",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5569",
    "data-name": "Path 5569",
    d: "M50.815,143.294H84.293L78.23,132.546,73.284,112.6H61.824l-4.946,19.949Z",
    fill: "#dbdbdb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7494",
    "data-name": "Group 7494"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_390",
    "data-name": "Rectangle 390",
    width: 1.202,
    height: 93.67,
    transform: "translate(106.306 0)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7493",
    "data-name": "Group 7493"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_391",
    "data-name": "Rectangle 391",
    width: 6.681,
    height: 4.517,
    transform: "translate(103.566 88.313)",
    fill: "#dbdbdb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_392",
    "data-name": "Rectangle 392",
    width: 6.681,
    height: 3.014,
    transform: "translate(103.566 89.816)",
    fill: "#c7c7c7"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5570",
    "data-name": "Path 5570",
    d: "M101.761,122.727a5.143,5.143,0,1,0,5.143-5.143A5.144,5.144,0,0,0,101.761,122.727Z",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5571",
    "data-name": "Path 5571",
    d: "M90.165,122.727h33.478L117.58,111.98l-4.946-19.949H101.174L96.228,111.98Z",
    fill: "#dbdbdb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7496",
    "data-name": "Group 7496"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_393",
    "data-name": "Rectangle 393",
    width: 1.202,
    height: 72.632,
    transform: "translate(143.12 0)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7495",
    "data-name": "Group 7495"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_394",
    "data-name": "Rectangle 394",
    width: 6.681,
    height: 4.517,
    transform: "translate(140.381 67.275)",
    fill: "#dbdbdb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_395",
    "data-name": "Rectangle 395",
    width: 6.681,
    height: 3.014,
    transform: "translate(140.381 68.778)",
    fill: "#c7c7c7"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5572",
    "data-name": "Path 5572",
    d: "M138.575,101.689a5.144,5.144,0,1,0,5.143-5.143A5.143,5.143,0,0,0,138.575,101.689Z",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5573",
    "data-name": "Path 5573",
    d: "M126.979,101.689h33.478l-6.063-10.747-4.946-19.949H137.988l-4.946,19.949Z",
    fill: "#dbdbdb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7501",
    "data-name": "Group 7501"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7498",
    "data-name": "Group 7498"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_396",
    "data-name": "Rectangle 396",
    width: 47.542,
    height: 57.668,
    transform: "translate(385.571 65.493)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_397",
    "data-name": "Rectangle 397",
    width: 36.677,
    height: 47.142,
    transform: "translate(391.004 70.756)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_398",
    "data-name": "Rectangle 398",
    width: 1.431,
    height: 47.142,
    transform: "translate(391.004 70.756)",
    fill: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_399",
    "data-name": "Rectangle 399",
    width: 1.431,
    height: 57.668,
    transform: "translate(433.113 65.493)",
    fill: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_400",
    "data-name": "Rectangle 400",
    width: 8.648,
    height: 25.765,
    transform: "translate(418.809 107.422) rotate(180)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_401",
    "data-name": "Rectangle 401",
    width: 23.06,
    height: 12.623,
    transform: "translate(422.582 89.879) rotate(180)",
    fill: "none",
    stroke: "#ebebeb",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7499",
    "data-name": "Group 7499"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_402",
    "data-name": "Rectangle 402",
    width: 47.542,
    height: 57.668,
    transform: "translate(385.571 207.609)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_403",
    "data-name": "Rectangle 403",
    width: 36.677,
    height: 47.142,
    transform: "translate(391.004 212.873)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_404",
    "data-name": "Rectangle 404",
    width: 1.431,
    height: 47.142,
    transform: "translate(391.004 212.873)",
    fill: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_405",
    "data-name": "Rectangle 405",
    width: 1.431,
    height: 57.668,
    transform: "translate(433.113 207.609)",
    fill: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_406",
    "data-name": "Rectangle 406",
    width: 8.648,
    height: 25.765,
    transform: "translate(403.295 223.774)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_407",
    "data-name": "Rectangle 407",
    width: 23.06,
    height: 12.623,
    transform: "translate(399.522 219.372)",
    fill: "none",
    stroke: "#ebebeb",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7500",
    "data-name": "Group 7500"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_408",
    "data-name": "Rectangle 408",
    width: 47.542,
    height: 57.668,
    transform: "translate(385.571 136.811)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_409",
    "data-name": "Rectangle 409",
    width: 36.677,
    height: 47.142,
    transform: "translate(391.004 142.074)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_410",
    "data-name": "Rectangle 410",
    width: 1.431,
    height: 47.142,
    transform: "translate(391.004 142.074)",
    fill: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_411",
    "data-name": "Rectangle 411",
    width: 1.431,
    height: 57.668,
    transform: "translate(433.113 136.811)",
    fill: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_412",
    "data-name": "Rectangle 412",
    width: 7.409,
    height: 18.733,
    transform: "translate(405.791 154.26)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_413",
    "data-name": "Rectangle 413",
    width: 19.903,
    height: 12.913,
    transform: "translate(401.098 165.645)",
    fill: "none",
    stroke: "#dbdbdb",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Shadow"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7502",
    "data-name": "Group 7502"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5574",
    "data-name": "Path 5574",
    d: "M448.314,449.031c0,11.277-88.788,20.419-198.314,20.419S51.686,460.308,51.686,449.031,140.474,428.613,250,428.613,448.314,437.754,448.314,449.031Z",
    fill: "#ebebeb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Floor"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_6",
    "data-name": "Line 6",
    x2: 417.02,
    transform: "translate(41.49 406.445)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Device"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7524",
    "data-name": "Group 7524"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7513",
    "data-name": "Group 7513"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5575",
    "data-name": "Path 5575",
    d: "M334.52,52.69H165.46a17.259,17.259,0,0,0-17.1,17.42V418.12a17.272,17.272,0,0,0,17.1,17.42H334.52a17.289,17.289,0,0,0,17.12-17.42V70.11A17.276,17.276,0,0,0,334.52,52.69Zm6.42,354.67c0,9.16-6.86,16.57-15.32,16.57H174.38c-8.48,0-15.34-7.41-15.34-16.57V83.3c0-18.66,6.86-19.57,15.34-19.57h30.3c1.76,0,3.2,2,3.2,4.48v1.07c0,5.81,3.18,5.83,7.08,5.83h70.06c3.94,0,7.1-.02,7.1-5.83V68.21c0-2.48,1.42-4.48,3.21-4.48h30.29c8.46,0,15.32,2.48,15.32,19.57Z",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_7",
    "data-name": "Line 7",
    x1: 0.57,
    transform: "translate(158.475 386.82)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7512",
    "data-name": "Group 7512"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5576",
    "data-name": "Path 5576",
    d: "M340.94,83.3V407.36c0,9.16-6.86,16.57-15.32,16.57H174.38c-8.48,0-15.34-7.41-15.34-16.57V83.3c0-18.66,6.86-19.57,15.34-19.57h30.3c1.76,0,3.2,2,3.2,4.48v1.07c0,5.81,3.18,5.83,7.08,5.83h70.06c3.94,0,7.1-.02,7.1-5.83V68.21c0-2.48,1.42-4.48,3.21-4.48h30.29C334.08,63.73,340.94,66.21,340.94,83.3Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7511",
    "data-name": "Group 7511"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5577",
    "data-name": "Path 5577",
    d: "M340.94,83.3v36.495H159.04V83.3c0-18.66,6.86-19.57,15.34-19.57h30.3c1.76,0,3.2,2,3.2,4.48v1.07c0,5.81,3.18,5.83,7.08,5.83h70.06c3.94,0,7.1-.02,7.1-5.83V68.21c0-2.48,1.42-4.48,3.21-4.48h30.29C334.08,63.73,340.94,66.21,340.94,83.3Z",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7506",
    "data-name": "Group 7506"
  }, /*#__PURE__*/React.createElement("g", {
    id: "u5Zjqx"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7503",
    "data-name": "Group 7503"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5578",
    "data-name": "Path 5578",
    d: "M199.448,71.009l-.293.29-.165.167a3.985,3.985,0,0,0-5.644,0c-.052-.054-.1-.11-.158-.165-.1-.1-.192-.194-.289-.29l-.008,0V71l.021-.018c.123-.11.243-.223.37-.328a4.577,4.577,0,0,1,1.991-.927c.187-.034.377-.052.567-.075.064-.008.483-.009.5-.008.129.009.258.015.386.029a4.376,4.376,0,0,1,1.041.248,4.559,4.559,0,0,1,.7.33,4.474,4.474,0,0,1,.672.47c.1.09.206.186.309.279Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5579",
    "data-name": "Path 5579",
    d: "M194.275,72.386l-.463-.459a3.263,3.263,0,0,1,1.882-.945,3.3,3.3,0,0,1,2.831.938l-.465.463a2.677,2.677,0,0,0-3.785,0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5580",
    "data-name": "Path 5580",
    d: "M197.6,72.847l-.46.46a1.366,1.366,0,0,0-1.939,0l-.46-.46A2.009,2.009,0,0,1,197.6,72.847Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5581",
    "data-name": "Path 5581",
    d: "M196.584,73.725a.415.415,0,1,1-.415-.415A.415.415,0,0,1,196.584,73.725Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7504",
    "data-name": "Group 7504"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5582",
    "data-name": "Path 5582",
    d: "M170.9,71.893A1.205,1.205,0,1,1,172.11,73.1,1.2,1.2,0,0,1,170.9,71.893Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5583",
    "data-name": "Path 5583",
    d: "M174.7,71.893a1.206,1.206,0,1,1,1.205,1.206A1.2,1.2,0,0,1,174.7,71.893Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5584",
    "data-name": "Path 5584",
    d: "M178.5,71.893A1.206,1.206,0,1,1,179.7,73.1,1.2,1.2,0,0,1,178.5,71.893Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5585",
    "data-name": "Path 5585",
    d: "M182.3,71.893A1.205,1.205,0,1,1,183.5,73.1,1.2,1.2,0,0,1,182.3,71.893Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5586",
    "data-name": "Path 5586",
    d: "M186.093,71.893A1.205,1.205,0,1,1,187.3,73.1,1.2,1.2,0,0,1,186.093,71.893Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7505",
    "data-name": "Group 7505"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5587",
    "data-name": "Path 5587",
    d: "M327.3,74.525h-9.814V69.979H327.3Zm-9.314-.5H326.8V70.479h-8.814Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_414",
    "data-name": "Rectangle 414",
    width: 6.326,
    height: 3.002,
    transform: "translate(318.298 70.751)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_415",
    "data-name": "Rectangle 415",
    width: 0.873,
    height: 2.432,
    transform: "translate(327.304 71.036)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7510",
    "data-name": "Group 7510"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7507",
    "data-name": "Group 7507"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5588",
    "data-name": "Path 5588",
    d: "M175.622,109.545l-5.374-5.035,5.374-5.035.834.888-4.425,4.147,4.425,4.147Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7508",
    "data-name": "Group 7508"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5589",
    "data-name": "Path 5589",
    d: "M324.378,99.475l5.374,5.035-5.374,5.035-.834-.888,4.426-4.147-4.426-4.147Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7509",
    "data-name": "Group 7509"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5590",
    "data-name": "Path 5590",
    d: "M239.787,102.441a3.593,3.593,0,0,1,0,4.949,3.2,3.2,0,0,1-2.338,1.046,3.3,3.3,0,0,1-2.4-1.046,3.647,3.647,0,0,1,0-4.949,3.26,3.26,0,0,1,2.4-1.046A3.166,3.166,0,0,1,239.787,102.441Zm-.127,2.475a2.534,2.534,0,0,0-.665-1.712,2.109,2.109,0,0,0-3.13,0,2.487,2.487,0,0,0-.665,1.712,2.442,2.442,0,0,0,.665,1.7,2.091,2.091,0,0,0,3.13,0A2.487,2.487,0,0,0,239.66,104.916Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5591",
    "data-name": "Path 5591",
    d: "M247.231,107.624a.541.541,0,0,1-.342.686.9.9,0,0,1-.215.029h-.01a.709.709,0,0,1-.381-.108.948.948,0,0,1-.313-.342,2.629,2.629,0,0,1-.206-1.174.835.835,0,0,0-.117-.421.915.915,0,0,0-.293-.283,1.881,1.881,0,0,0-.548-.235h-1.155V107.9a.544.544,0,0,1-.547.538.536.536,0,0,1-.538-.538v-5.77a.531.531,0,0,1,.538-.538h1.751a2.092,2.092,0,0,1,1.33,3.707,1.52,1.52,0,0,1,.342.362,1.846,1.846,0,0,1,.323,1.056,2.491,2.491,0,0,0,.039.577A.526.526,0,0,1,247.231,107.624Zm-1.369-3.931a1.008,1.008,0,0,0-1.007-1.017h-1.2v2.014h1.2A1,1,0,0,0,245.862,103.693Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5592",
    "data-name": "Path 5592",
    d: "M248.816,107.9v-5.77a.531.531,0,0,1,.539-.538h1.154a3.423,3.423,0,0,1,0,6.846h-1.154A.536.536,0,0,1,248.816,107.9Zm1.086-.547h.607a2.338,2.338,0,0,0,0-4.675H249.9Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5593",
    "data-name": "Path 5593",
    d: "M255.362,107.9v-5.77a.53.53,0,0,1,.537-.538h3.2a.542.542,0,0,1,.537.538.551.551,0,0,1-.537.548h-2.651v1.789h2.279a.543.543,0,0,1,0,1.086h-2.279v1.8H259.1a.543.543,0,0,1,0,1.085h-3.169c-.019,0-.019-.009-.019-.009l-.011.009A.535.535,0,0,1,255.362,107.9Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5594",
    "data-name": "Path 5594",
    d: "M265.886,107.624a.541.541,0,0,1-.343.686.9.9,0,0,1-.214.029h-.01a.716.716,0,0,1-.382-.108.954.954,0,0,1-.312-.342,2.629,2.629,0,0,1-.206-1.174.815.815,0,0,0-.118-.421.894.894,0,0,0-.293-.283,1.87,1.87,0,0,0-.548-.235h-1.154V107.9a.544.544,0,0,1-.548.538.537.537,0,0,1-.538-.538v-5.77a.531.531,0,0,1,.538-.538h1.751a2.092,2.092,0,0,1,1.33,3.707,1.5,1.5,0,0,1,.343.362,1.853,1.853,0,0,1,.322,1.056,2.552,2.552,0,0,0,.039.577A.523.523,0,0,1,265.886,107.624Zm-1.369-3.931a1.008,1.008,0,0,0-1.008-1.017h-1.2v2.014h1.2A1,1,0,0,0,264.517,103.693Z",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_5595",
    "data-name": "Path 5595",
    d: "M259.551,67.853h-19.11a1.18,1.18,0,0,1-1.181-1.18h0a1.18,1.18,0,0,1,1.181-1.18h19.11a1.18,1.18,0,0,1,1.181,1.18h0A1.18,1.18,0,0,1,259.551,67.853Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7523",
    "data-name": "Group 7523"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7514",
    "data-name": "Group 7514"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5596",
    "data-name": "Path 5596",
    d: "M188.856,252.339l-2.4,3.291v3.162a.635.635,0,0,1-.644.645.65.65,0,0,1-.644-.645V255.63l-2.378-3.291a.615.615,0,0,1,.129-.89.624.624,0,0,1,.89.141l2,2.74,2-2.74a.642.642,0,0,1,1.042.749Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5597",
    "data-name": "Path 5597",
    d: "M189.351,258.582a2.926,2.926,0,0,1-.808-2.061,3.024,3.024,0,0,1,.808-2.05,2.735,2.735,0,0,1,2.015-.89,2.588,2.588,0,0,1,1.956.89,2.926,2.926,0,0,1,.82,2.05,2.835,2.835,0,0,1-.82,2.061,2.591,2.591,0,0,1-1.956.89A2.738,2.738,0,0,1,189.351,258.582Zm.469-2.061a1.891,1.891,0,0,0,.422,1.241,1.585,1.585,0,0,0,1.124.433,1.535,1.535,0,0,0,1.078-.433,1.8,1.8,0,0,0,.457-1.241,1.761,1.761,0,0,0-.457-1.219,1.654,1.654,0,0,0-1.078-.445,1.7,1.7,0,0,0-1.124.445A1.85,1.85,0,0,0,189.82,256.521Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5598",
    "data-name": "Path 5598",
    d: "M198.269,259.437A2.45,2.45,0,0,1,195.833,257v-2.8a.632.632,0,0,1,.62-.62.625.625,0,0,1,.621.62V257a1.185,1.185,0,0,0,1.195,1.2,1.216,1.216,0,0,0,1.23-1.2v-2.8a.614.614,0,0,1,.609-.62.651.651,0,0,1,.632.62V257A2.473,2.473,0,0,1,198.269,259.437Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5599",
    "data-name": "Path 5599",
    d: "M206.741,254.2a.625.625,0,0,1-.621.621,1.128,1.128,0,0,0-.7.222,1.768,1.768,0,0,0-.539.563,3.609,3.609,0,0,0-.48.983v2.226a.638.638,0,0,1-.644.621.625.625,0,0,1-.621-.621V254.2a.615.615,0,0,1,.621-.609.628.628,0,0,1,.644.609v.082a1.546,1.546,0,0,1,.246-.234,2.577,2.577,0,0,1,1.476-.457A.608.608,0,0,1,206.741,254.2Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5600",
    "data-name": "Path 5600",
    d: "M212.332,258.582a2.926,2.926,0,0,1-.808-2.061,3.024,3.024,0,0,1,.808-2.05,2.736,2.736,0,0,1,2.015-.89,2.588,2.588,0,0,1,1.956.89,2.926,2.926,0,0,1,.82,2.05,2.835,2.835,0,0,1-.82,2.061,2.591,2.591,0,0,1-1.956.89A2.74,2.74,0,0,1,212.332,258.582Zm.469-2.061a1.891,1.891,0,0,0,.422,1.241,1.585,1.585,0,0,0,1.124.433,1.535,1.535,0,0,0,1.078-.433,1.8,1.8,0,0,0,.457-1.241,1.761,1.761,0,0,0-.457-1.219,1.654,1.654,0,0,0-1.078-.445,1.7,1.7,0,0,0-1.124.445A1.85,1.85,0,0,0,212.8,256.521Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5601",
    "data-name": "Path 5601",
    d: "M222.491,254.2a.625.625,0,0,1-.62.621,1.126,1.126,0,0,0-.7.222,1.758,1.758,0,0,0-.539.563,3.579,3.579,0,0,0-.48.983v2.226a.638.638,0,0,1-.645.621.625.625,0,0,1-.62-.621V254.2a.615.615,0,0,1,.62-.609.629.629,0,0,1,.645.609v.082a1.545,1.545,0,0,1,.246-.234,2.577,2.577,0,0,1,1.476-.457A.608.608,0,0,1,222.491,254.2Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5602",
    "data-name": "Path 5602",
    d: "M229.041,258.8a.633.633,0,0,1-1.253.128,2.853,2.853,0,0,1-1.593.5,2.929,2.929,0,0,1,0-5.856,2.779,2.779,0,0,1,1.57.491v-2.2a.638.638,0,0,1,1.276,0V258.8Zm-2.846-3.948a1.516,1.516,0,0,0-1.1.48,1.7,1.7,0,0,0,0,2.343,1.512,1.512,0,0,0,1.1.48,1.494,1.494,0,0,0,1.1-.48,1.7,1.7,0,0,0,0-2.343A1.5,1.5,0,0,0,226.2,254.857Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5603",
    "data-name": "Path 5603",
    d: "M230.884,256.508a2.9,2.9,0,0,1,2.858-2.927,2.8,2.8,0,0,1,2.823,2.716v.06a.308.308,0,0,1-.012.1.565.565,0,0,1-.609.47H232.22a1.528,1.528,0,0,0,.4.772,1.812,1.812,0,0,0,1.124.528,1.918,1.918,0,0,0,1.218-.293.663.663,0,0,1,.879-.035.535.535,0,0,1,0,.761,2.961,2.961,0,0,1-2.1.773A2.908,2.908,0,0,1,230.884,256.508Zm1.277-.573h3.315a1.915,1.915,0,0,0-1.734-1.242A1.637,1.637,0,0,0,232.161,255.935Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5604",
    "data-name": "Path 5604",
    d: "M241.793,254.2a.625.625,0,0,1-.621.621,1.13,1.13,0,0,0-.7.222,1.779,1.779,0,0,0-.539.563,3.639,3.639,0,0,0-.48.983v2.226a.638.638,0,0,1-.644.621.625.625,0,0,1-.621-.621V254.2a.615.615,0,0,1,.621-.609.628.628,0,0,1,.644.609v.082a1.546,1.546,0,0,1,.246-.234,2.582,2.582,0,0,1,1.476-.457A.608.608,0,0,1,241.793,254.2Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5605",
    "data-name": "Path 5605",
    d: "M248.122,252.116a.632.632,0,0,1-.632.645.64.64,0,0,1-.633-.645v-.245a.63.63,0,0,1,.633-.633.622.622,0,0,1,.632.633Zm0,2.121V258.8a.622.622,0,0,1-.632.632.63.63,0,0,1-.633-.632v-4.568a.626.626,0,0,1,.633-.645A.619.619,0,0,1,248.122,254.237Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5606",
    "data-name": "Path 5606",
    d: "M249.858,257.762a.609.609,0,0,1,.878-.094,2.161,2.161,0,0,0,1.288.516,1.566,1.566,0,0,0,.8-.223.479.479,0,0,0,.21-.351.18.18,0,0,0-.034-.118c-.012-.035-.059-.082-.153-.14a2.717,2.717,0,0,0-.936-.328H251.9a4.487,4.487,0,0,1-1.019-.3,1.958,1.958,0,0,1-.809-.68,1.427,1.427,0,0,1-.2-.738,1.647,1.647,0,0,1,.691-1.288,2.521,2.521,0,0,1,1.441-.433,3.008,3.008,0,0,1,1.757.644.646.646,0,0,1,.187.866.619.619,0,0,1-.866.164,2.007,2.007,0,0,0-1.078-.433,1.186,1.186,0,0,0-.7.211.363.363,0,0,0-.188.269.123.123,0,0,0,.024.094.338.338,0,0,0,.129.118,2.415,2.415,0,0,0,.854.28l.013.012h.011a4.221,4.221,0,0,1,1.09.34,1.821,1.821,0,0,1,.832.69,1.524,1.524,0,0,1,.221.774,1.689,1.689,0,0,1-.737,1.359,2.665,2.665,0,0,1-1.523.468,3.4,3.4,0,0,1-2.084-.809A.624.624,0,0,1,249.858,257.762Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5607",
    "data-name": "Path 5607",
    d: "M259.01,256.521a2.979,2.979,0,0,1,2.974-2.94,3.086,3.086,0,0,1,1.863.644.643.643,0,0,1,.129.866.624.624,0,0,1-.879.117,1.872,1.872,0,0,0-1.113-.374,1.681,1.681,0,1,0,0,3.361,1.892,1.892,0,0,0,1.113-.375.639.639,0,0,1,.879.129.647.647,0,0,1-.129.867,3.223,3.223,0,0,1-1.863.621A2.967,2.967,0,0,1,259.01,256.521Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5608",
    "data-name": "Path 5608",
    d: "M266.475,258.582a2.922,2.922,0,0,1-.809-2.061,3.02,3.02,0,0,1,.809-2.05,2.732,2.732,0,0,1,2.014-.89,2.592,2.592,0,0,1,1.957.89,2.93,2.93,0,0,1,.819,2.05,2.838,2.838,0,0,1-.819,2.061,2.6,2.6,0,0,1-1.957.89A2.736,2.736,0,0,1,266.475,258.582Zm.469-2.061a1.89,1.89,0,0,0,.421,1.241,1.583,1.583,0,0,0,1.124.433,1.529,1.529,0,0,0,1.077-.433,1.8,1.8,0,0,0,.458-1.241,1.757,1.757,0,0,0-.458-1.219,1.648,1.648,0,0,0-1.077-.445,1.7,1.7,0,0,0-1.124.445A1.849,1.849,0,0,0,266.944,256.521Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5609",
    "data-name": "Path 5609",
    d: "M278.144,256.017v2.8a.614.614,0,0,1-.608.621.633.633,0,0,1-.621-.621v-2.8a1.2,1.2,0,0,0-1.218-1.183,1.169,1.169,0,0,0-1.171,1.183v2.8a.224.224,0,0,1-.024.117.641.641,0,0,1-.621.5.618.618,0,0,1-.621-.621V254.2a.618.618,0,0,1,.621-.62.633.633,0,0,1,.574.363,2.334,2.334,0,0,1,1.242-.363A2.451,2.451,0,0,1,278.144,256.017Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5610",
    "data-name": "Path 5610",
    d: "M282.364,253.194v.164h.352a.642.642,0,0,1,.644.644.65.65,0,0,1-.644.645h-.352v4.134a.644.644,0,0,1-1.288,0v-4.134h-.3a.653.653,0,0,1-.657-.645.645.645,0,0,1,.657-.644h.3v-.164a2.425,2.425,0,0,1,.223-1.148,1.393,1.393,0,0,1,.843-.726,2.379,2.379,0,0,1,.7-.093.65.65,0,0,1,0,1.3.82.82,0,0,0-.3.036.116.116,0,0,0-.07.035A1.055,1.055,0,0,0,282.364,253.194Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5611",
    "data-name": "Path 5611",
    d: "M285.963,252.116a.633.633,0,0,1-.633.645.64.64,0,0,1-.633-.645v-.245a.63.63,0,0,1,.633-.633.623.623,0,0,1,.633.633Zm0,2.121V258.8a.623.623,0,0,1-.633.632.63.63,0,0,1-.633-.632v-4.568a.626.626,0,0,1,.633-.645A.62.62,0,0,1,285.963,254.237Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5612",
    "data-name": "Path 5612",
    d: "M291.587,254.2a.625.625,0,0,1-.621.621,1.126,1.126,0,0,0-.7.222,1.768,1.768,0,0,0-.539.563,3.579,3.579,0,0,0-.48.983v2.226a.638.638,0,0,1-.644.621.625.625,0,0,1-.621-.621V254.2a.615.615,0,0,1,.621-.609.628.628,0,0,1,.644.609v.082a1.54,1.54,0,0,1,.245-.234,2.585,2.585,0,0,1,1.477-.457A.608.608,0,0,1,291.587,254.2Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5613",
    "data-name": "Path 5613",
    d: "M298.02,256.005v2.811a.625.625,0,0,1-.621.621.643.643,0,0,1-.632-.621v-2.811a1.2,1.2,0,0,0-2.39.035v2.776c0,.023-.011.058-.011.082v.035c-.012.023-.012.047-.036.07v.059a.681.681,0,0,1-.585.375c-.047,0-.082-.012-.117-.012a.638.638,0,0,1-.5-.609v-4.6a.62.62,0,0,1,.621-.632.6.6,0,0,1,.563.351,2.464,2.464,0,0,1,1.253-.351,2.428,2.428,0,0,1,1.838.808,2.41,2.41,0,0,1,1.839-.808,2.447,2.447,0,0,1,2.436,2.459v2.776a.624.624,0,0,1-.62.621.635.635,0,0,1-.633-.621V256.04a1.2,1.2,0,0,0-1.183-1.206A1.216,1.216,0,0,0,298.02,256.005Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5614",
    "data-name": "Path 5614",
    d: "M303.858,256.508a2.9,2.9,0,0,1,2.858-2.927,2.8,2.8,0,0,1,2.823,2.716v.06a.309.309,0,0,1-.012.1.564.564,0,0,1-.609.47h-3.725a1.537,1.537,0,0,0,.4.772,1.812,1.812,0,0,0,1.124.528,1.918,1.918,0,0,0,1.218-.293.663.663,0,0,1,.879-.035.535.535,0,0,1,0,.761,2.962,2.962,0,0,1-2.1.773A2.908,2.908,0,0,1,303.858,256.508Zm1.277-.573h3.315a1.915,1.915,0,0,0-1.734-1.242A1.636,1.636,0,0,0,305.135,255.935Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5615",
    "data-name": "Path 5615",
    d: "M316.712,258.8a.634.634,0,0,1-1.254.128,2.851,2.851,0,0,1-1.593.5,2.929,2.929,0,0,1,0-5.856,2.776,2.776,0,0,1,1.57.491v-2.2a.639.639,0,0,1,1.277,0V258.8Zm-2.847-3.948a1.516,1.516,0,0,0-1.1.48,1.7,1.7,0,0,0,0,2.343,1.512,1.512,0,0,0,1.1.48,1.5,1.5,0,0,0,1.1-.48,1.7,1.7,0,0,0,0-2.343A1.5,1.5,0,0,0,313.865,254.857Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7515",
    "data-name": "Group 7515"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5616",
    "data-name": "Path 5616",
    d: "M221.718,236.885h-2.471a.287.287,0,0,1,0-.574h5.505a.287.287,0,0,1,0,.574h-2.471v7.344a.282.282,0,0,1-.563,0Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5617",
    "data-name": "Path 5617",
    d: "M231.046,241.031a1.827,1.827,0,0,0-3.643,0v3.233c0,.023-.011.035-.011.047s-.012.035-.024.047a.266.266,0,0,1-.175.14.042.042,0,0,1-.024.012h-.058a.324.324,0,0,1-.223-.093.393.393,0,0,1-.047-.094.256.256,0,0,1-.012-.094v-7.637a.287.287,0,0,1,.574,0v3.022a2.374,2.374,0,0,1,1.816-.843,2.288,2.288,0,0,1,2.4,2.26v3.2a.287.287,0,0,1-.574,0Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5618",
    "data-name": "Path 5618",
    d: "M239.3,239.052v5.177a.281.281,0,0,1-.562,0v-.855a2.68,2.68,0,0,1-2.155,1.136,2.874,2.874,0,0,1,0-5.739,2.669,2.669,0,0,1,2.155,1.124v-.843a.281.281,0,0,1,.562,0Zm-.562,2.588a2.161,2.161,0,1,0-2.155,2.308A2.242,2.242,0,0,0,238.734,241.64Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5619",
    "data-name": "Path 5619",
    d: "M245.718,241.113a1.767,1.767,0,0,0-1.769-1.768,1.8,1.8,0,0,0-1.78,1.768v3.163a.266.266,0,0,1-.058.129.251.251,0,0,1-.211.1h-.071a.308.308,0,0,1-.187-.152.042.042,0,0,1-.012-.035.042.042,0,0,0-.012-.024v-5.236a.277.277,0,0,1,.282-.28.274.274,0,0,1,.269.28v.551a2.328,2.328,0,0,1,4.111,1.5v3.116a.281.281,0,0,1-.562,0Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5620",
    "data-name": "Path 5620",
    d: "M248.8,236.592a.287.287,0,0,1,.574,0v5.517l3.4-3.385a.281.281,0,1,1,.4.4l-2.213,2.214,2.226,2.706a.275.275,0,0,1-.212.468.241.241,0,0,1-.222-.1l-2.2-2.659-1.172,1.171v1.312a.287.287,0,0,1-.574,0Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5621",
    "data-name": "Path 5621",
    d: "M258.4,239.04a.272.272,0,0,1,.269-.269.279.279,0,0,1,.294.269v3.116a1.757,1.757,0,0,0,1.757,1.769,1.776,1.776,0,0,0,1.779-1.769V239.04a.2.2,0,0,1,.048-.14c0-.012.012-.024.012-.035s.011-.012.022-.012a.211.211,0,0,1,.106-.07h.024c.012,0,.023-.012.035-.012h.07a.737.737,0,0,1,.141.058.3.3,0,0,1,.07.094.22.22,0,0,1,.035.117v5.013a2.7,2.7,0,0,1-2.729,2.694,2.868,2.868,0,0,1-1.183-.269.289.289,0,0,1-.116-.375.3.3,0,0,1,.362-.14,2.129,2.129,0,0,0,.937.222,2.153,2.153,0,0,0,2.166-2.132v-.375a2.326,2.326,0,0,1-4.1-1.522Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5622",
    "data-name": "Path 5622",
    d: "M267.868,238.771a2.874,2.874,0,1,1-2.717,2.869A2.807,2.807,0,0,1,267.868,238.771Zm0,5.177a2.319,2.319,0,1,0-2.155-2.308A2.246,2.246,0,0,0,267.868,243.948Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5623",
    "data-name": "Path 5623",
    d: "M272.441,239.04a.281.281,0,1,1,.562,0v3.128a1.769,1.769,0,1,0,3.537,0V239.04a.284.284,0,0,1,.281-.281.281.281,0,0,1,.293.281v3.128a2.337,2.337,0,1,1-4.673,0Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5624",
    "data-name": "Path 5624",
    d: "M279.741,236.592a.285.285,0,0,1,.281-.281.288.288,0,0,1,.293.281v5.88a.29.29,0,0,1-.293.293.287.287,0,0,1-.281-.293Zm0,7.356a.285.285,0,0,1,.281-.281.288.288,0,0,1,.293.281v.281a.288.288,0,0,1-.293.281.285.285,0,0,1-.281-.281Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7519",
    "data-name": "Group 7519"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5625",
    "data-name": "Path 5625",
    d: "M247.745,208.894l-8.45-8.553,2.839-2.8,4.936,5,10.255-16.076,3.365,2.146Z",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5626",
    "data-name": "Path 5626",
    d: "M249.993,219.764a22.09,22.09,0,1,1,22.089-22.089A22.114,22.114,0,0,1,249.993,219.764Zm0-41.179a19.09,19.09,0,1,0,19.089,19.09A19.112,19.112,0,0,0,249.993,178.585Z",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7518",
    "data-name": "Group 7518"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7516",
    "data-name": "Group 7516"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_416",
    "data-name": "Rectangle 416",
    width: 6.561,
    height: 1,
    transform: "translate(215.667 197.175)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_417",
    "data-name": "Rectangle 417",
    width: 1,
    height: 6.561,
    transform: "matrix(0.707, -0.707, 0.707, 0.707, 219.248, 183.972)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_418",
    "data-name": "Rectangle 418",
    width: 6.561,
    height: 1,
    transform: "translate(219.248 211.16) rotate(-45)",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7517",
    "data-name": "Group 7517"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_419",
    "data-name": "Rectangle 419",
    width: 6.561,
    height: 1,
    transform: "translate(277.757 197.175)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_420",
    "data-name": "Rectangle 420",
    width: 6.561,
    height: 1,
    transform: "translate(275.391 187.904) rotate(-45)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_421",
    "data-name": "Rectangle 421",
    width: 1,
    height: 6.56,
    transform: "matrix(0.707, -0.707, 0.707, 0.707, 275.392, 207.228)",
    fill: "#ff725e"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7521",
    "data-name": "Group 7521"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_422",
    "data-name": "Rectangle 422",
    width: 59.668,
    height: 20.049,
    transform: "translate(220.159 299.019)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7520",
    "data-name": "Group 7520"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5627",
    "data-name": "Path 5627",
    d: "M234.343,312.617v-6.911a.636.636,0,0,1,.644-.645h1.382a4.1,4.1,0,0,1,0,8.2h-1.382A.641.641,0,0,1,234.343,312.617Zm1.3-.657h.726a2.8,2.8,0,0,0,0-5.6h-.726Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5628",
    "data-name": "Path 5628",
    d: "M249.058,306.081a4.3,4.3,0,0,1,0,5.926,3.837,3.837,0,0,1-2.8,1.253,3.953,3.953,0,0,1-2.869-1.253,4.364,4.364,0,0,1,0-5.926,3.9,3.9,0,0,1,2.869-1.253A3.789,3.789,0,0,1,249.058,306.081Zm-.152,2.963a3.029,3.029,0,0,0-.8-2.049,2.519,2.519,0,0,0-1.85-.832,2.55,2.55,0,0,0-1.9.832,2.982,2.982,0,0,0-.8,2.049,2.932,2.932,0,0,0,.8,2.038,2.563,2.563,0,0,0,1.9.843,2.534,2.534,0,0,0,1.85-.843A2.979,2.979,0,0,0,248.906,309.044Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5629",
    "data-name": "Path 5629",
    d: "M253.538,312.617a.639.639,0,1,1-1.277,0V305.8a.63.63,0,0,1,.258-.538.645.645,0,0,1,.89.14l3.784,5.236v-4.826a.637.637,0,0,1,.632-.632.647.647,0,0,1,.645.632v6.806a.649.649,0,0,1-.645.643.633.633,0,0,1-.48-.234.282.282,0,0,1-.059-.07l-3.748-5.2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5630",
    "data-name": "Path 5630",
    d: "M260.524,312.617v-6.911a.636.636,0,0,1,.645-.645H265a.65.65,0,0,1,.643.645.66.66,0,0,1-.643.655h-3.175v2.144h2.729a.65.65,0,0,1,0,1.3h-2.729v2.155H265a.65.65,0,0,1,0,1.3H261.2c-.024,0-.024-.011-.024-.011l-.011.011A.642.642,0,0,1,260.524,312.617Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7522",
    "data-name": "Group 7522"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5631",
    "data-name": "Path 5631",
    d: "M194.838,271.5l-1.525-2.082a.169.169,0,0,1,.034-.221.148.148,0,0,1,.219.027l1.421,1.952,1.427-1.952a.149.149,0,0,1,.22-.027.156.156,0,0,1,.033.221l-1.518,2.068v2.037a.154.154,0,0,1-.156.156.158.158,0,0,1-.155-.156Z",
    fill: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5632",
    "data-name": "Path 5632",
    d: "M198.08,270.5a1.591,1.591,0,1,1-1.505,1.589A1.554,1.554,0,0,1,198.08,270.5Zm0,2.866a1.284,1.284,0,1,0-1.193-1.277A1.243,1.243,0,0,0,198.08,273.368Z",
    fill: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5633",
    "data-name": "Path 5633",
    d: "M200.608,270.651a.156.156,0,1,1,.312,0v1.732a.98.98,0,1,0,1.959,0v-1.732a.157.157,0,0,1,.155-.156.155.155,0,0,1,.162.156v1.732a1.294,1.294,0,1,1-2.588,0Z",
    fill: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5634",
    "data-name": "Path 5634",
    d: "M207.657,273.653a.111.111,0,0,1-.064-.071l-1.194-2.84a.159.159,0,0,1,.078-.2.155.155,0,0,1,.2.084l1.056,2.5.733-1.745a.168.168,0,0,1,.3,0l.733,1.745,1.051-2.5a.158.158,0,0,1,.2-.084.156.156,0,0,1,.084.2l-1.187,2.827a.179.179,0,0,1-.058.078.135.135,0,0,1-.078.033h-.033a.149.149,0,0,1-.123-.1l-.007-.006-.739-1.758-.732,1.751a.024.024,0,0,0-.007.013.153.153,0,0,1-.136.1.2.2,0,0,1-.058-.013A.036.036,0,0,1,207.657,273.653Z",
    fill: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5635",
    "data-name": "Path 5635",
    d: "M211.781,269.62a.158.158,0,0,1,.156-.155.16.16,0,0,1,.163.155v.15a.16.16,0,1,1-.319,0Zm0,1.037a.154.154,0,0,1,.156-.155.156.156,0,0,1,.163.155v2.867a.16.16,0,0,1-.319,0Z",
    fill: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5636",
    "data-name": "Path 5636",
    d: "M213.507,269.3a.159.159,0,0,1,.317,0v4.228a.159.159,0,0,1-.317,0Z",
    fill: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5637",
    "data-name": "Path 5637",
    d: "M215.121,269.3a.159.159,0,0,1,.317,0v4.228a.159.159,0,0,1-.317,0Z",
    fill: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5638",
    "data-name": "Path 5638",
    d: "M218.636,272.162V269.3a.159.159,0,0,1,.317,0v1.829a1.515,1.515,0,0,1,1.22-.623,1.59,1.59,0,0,1,0,3.178,1.512,1.512,0,0,1-1.22-.616v.46a.159.159,0,0,1-.317,0Zm.317-.064a1.253,1.253,0,1,0,0-.052Z",
    fill: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5639",
    "data-name": "Path 5639",
    d: "M222.688,272.1a1.539,1.539,0,0,1,3.075-.118v.027a.148.148,0,0,1-.157.142H223a1.249,1.249,0,0,0,1.231,1.219,1.2,1.2,0,0,0,1.026-.577.151.151,0,0,1,.207-.052.167.167,0,0,1,.052.221,1.515,1.515,0,0,1-1.285.72A1.564,1.564,0,0,1,222.688,272.1Zm.331-.253h2.406a1.227,1.227,0,0,0-1.194-1.031A1.24,1.24,0,0,0,223.019,271.845Z",
    fill: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5640",
    "data-name": "Path 5640",
    d: "M228.81,270.664a.154.154,0,0,1,.162-.155.151.151,0,0,1,.149.155v.7a.478.478,0,0,1,.045-.077,1.53,1.53,0,0,1,1.271-.778.153.153,0,0,1,.156.155.158.158,0,0,1-.156.155,1.145,1.145,0,0,0-.92.52,2.839,2.839,0,0,0-.383.739.1.1,0,0,0-.013.052v1.394a.152.152,0,0,1-.149.156.155.155,0,0,1-.162-.156Z",
    fill: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5641",
    "data-name": "Path 5641",
    d: "M231.1,272.1a1.539,1.539,0,0,1,3.075-.118v.027a.147.147,0,0,1-.156.142h-2.607a1.249,1.249,0,0,0,1.232,1.219,1.2,1.2,0,0,0,1.025-.577.152.152,0,0,1,.208-.052.168.168,0,0,1,.052.221,1.516,1.516,0,0,1-1.285.72A1.564,1.564,0,0,1,231.1,272.1Zm.331-.253h2.407a1.228,1.228,0,0,0-1.194-1.031A1.242,1.242,0,0,0,231.435,271.845Z",
    fill: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5642",
    "data-name": "Path 5642",
    d: "M235.054,272.084a1.6,1.6,0,0,1,1.634-1.582,1.634,1.634,0,0,1,1.012.351.146.146,0,0,1,.02.213.158.158,0,0,1-.214.026,1.3,1.3,0,1,0-.818,2.276,1.342,1.342,0,0,0,.818-.278.161.161,0,0,1,.214.025.155.155,0,0,1-.034.228,1.639,1.639,0,0,1-1,.337A1.6,1.6,0,0,1,235.054,272.084Z",
    fill: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5643",
    "data-name": "Path 5643",
    d: "M238.659,272.1a1.538,1.538,0,0,1,3.074-.118v.027a.146.146,0,0,1-.155.142h-2.607a1.249,1.249,0,0,0,1.232,1.219,1.193,1.193,0,0,0,1.024-.577.153.153,0,0,1,.208-.052.166.166,0,0,1,.052.221,1.513,1.513,0,0,1-1.284.72A1.564,1.564,0,0,1,238.659,272.1Zm.331-.253H241.4a1.226,1.226,0,0,0-1.193-1.031A1.24,1.24,0,0,0,238.99,271.845Z",
    fill: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5644",
    "data-name": "Path 5644",
    d: "M242.842,269.62a.159.159,0,0,1,.317,0v.15a.159.159,0,1,1-.317,0Zm0,1.037A.153.153,0,0,1,243,270.5a.155.155,0,0,1,.162.155v2.867a.159.159,0,0,1-.317,0Z",
    fill: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5645",
    "data-name": "Path 5645",
    d: "M245.676,273.653a.18.18,0,0,1-.052-.071l-1.193-2.84a.157.157,0,0,1,.078-.2.153.153,0,0,1,.2.084l1.058,2.5,1.056-2.5a.154.154,0,0,1,.2-.084.152.152,0,0,1,.078.2l-1.186,2.815a.259.259,0,0,1-.039.078.139.139,0,0,1-.1.045.134.134,0,0,1-.052-.007c-.006,0-.006,0-.013-.006S245.688,273.66,245.676,273.653Z",
    fill: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5646",
    "data-name": "Path 5646",
    d: "M248.437,269.62a.16.16,0,0,1,.319,0v.15a.16.16,0,1,1-.319,0Zm0,1.037a.16.16,0,0,1,.319,0v2.867a.16.16,0,0,1-.319,0Z",
    fill: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5647",
    "data-name": "Path 5647",
    d: "M252.523,271.8a.979.979,0,0,0-.979-.98,1,1,0,0,0-.985.98v1.751a.141.141,0,0,1-.033.071.139.139,0,0,1-.117.059h-.039a.168.168,0,0,1-.1-.084.025.025,0,0,1-.007-.02.021.021,0,0,0-.006-.013v-2.9a.153.153,0,1,1,.305,0v.3a1.289,1.289,0,0,1,2.276.83v1.725a.156.156,0,1,1-.312,0Z",
    fill: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5648",
    "data-name": "Path 5648",
    d: "M257,273.427a1.493,1.493,0,0,1-1.5,1.491,1.649,1.649,0,0,1-.661-.148.168.168,0,0,1-.066-.209.145.145,0,0,1,.208-.071,1.147,1.147,0,0,0,.519.117,1.177,1.177,0,0,0,1.186-1.18v-.389a1.438,1.438,0,0,1-1.186.622,1.582,1.582,0,0,1,0-3.158,1.452,1.452,0,0,1,1.186.623v-.468a.159.159,0,0,1,.162-.155.156.156,0,0,1,.15.155Zm-.312-1.349a1.187,1.187,0,1,0-1.186,1.277A1.221,1.221,0,0,0,256.692,272.078Z",
    fill: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5649",
    "data-name": "Path 5649",
    d: "M263.119,270.657v2.867a.155.155,0,1,1-.311,0v-.473a1.485,1.485,0,0,1-1.194.629,1.591,1.591,0,0,1,0-3.178,1.477,1.477,0,0,1,1.194.623v-.468a.155.155,0,0,1,.311,0Zm-.311,1.434a1.2,1.2,0,1,0-1.194,1.277A1.242,1.242,0,0,0,262.808,272.091Z",
    fill: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5650",
    "data-name": "Path 5650",
    d: "M266.185,272.084a1.6,1.6,0,0,1,1.634-1.582,1.632,1.632,0,0,1,1.012.351.145.145,0,0,1,.02.213.158.158,0,0,1-.214.026,1.295,1.295,0,1,0-.818,2.276,1.339,1.339,0,0,0,.818-.278.161.161,0,0,1,.214.025.155.155,0,0,1-.033.228,1.642,1.642,0,0,1-1,.337A1.6,1.6,0,0,1,266.185,272.084Z",
    fill: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5651",
    "data-name": "Path 5651",
    d: "M271.373,270.5a1.591,1.591,0,1,1-1.5,1.589A1.554,1.554,0,0,1,271.373,270.5Zm0,2.866a1.284,1.284,0,1,0-1.193-1.277A1.243,1.243,0,0,0,271.373,273.368Z",
    fill: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5652",
    "data-name": "Path 5652",
    d: "M276.341,271.8a.98.98,0,0,0-.98-.98,1,1,0,0,0-.985.98v1.751a.15.15,0,0,1-.033.071.14.14,0,0,1-.116.059h-.04a.17.17,0,0,1-.1-.084.025.025,0,0,1-.007-.02.021.021,0,0,0-.006-.013v-2.9a.153.153,0,1,1,.3,0v.3a1.289,1.289,0,0,1,2.276.83v1.725a.156.156,0,1,1-.311,0Z",
    fill: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5653",
    "data-name": "Path 5653",
    d: "M279.446,269.309a.157.157,0,0,1-.155.156c-.221,0-.338.045-.4.123a.772.772,0,0,0-.13.525v.337h.447a.159.159,0,1,1,0,.318h-.447v2.762a.159.159,0,0,1-.318,0v-2.762h-.422a.16.16,0,0,1-.155-.163.158.158,0,0,1,.155-.155h.422v-.337a1.126,1.126,0,0,1,.207-.739.845.845,0,0,1,.643-.227A.159.159,0,0,1,279.446,269.309Z",
    fill: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5654",
    "data-name": "Path 5654",
    d: "M280.4,269.62a.16.16,0,0,1,.319,0v.15a.16.16,0,1,1-.319,0Zm0,1.037a.16.16,0,0,1,.319,0v2.867a.16.16,0,0,1-.319,0Z",
    fill: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5655",
    "data-name": "Path 5655",
    d: "M282.215,270.664a.154.154,0,0,1,.162-.155.151.151,0,0,1,.148.155v.7a.707.707,0,0,1,.046-.077,1.53,1.53,0,0,1,1.271-.778.153.153,0,0,1,.156.155.157.157,0,0,1-.156.155,1.149,1.149,0,0,0-.921.52,2.828,2.828,0,0,0-.382.739.091.091,0,0,0-.014.052v1.394a.152.152,0,0,1-.148.156.155.155,0,0,1-.162-.156Z",
    fill: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5656",
    "data-name": "Path 5656",
    d: "M289.607,271.8a1,1,0,0,0-.986-.985.987.987,0,0,0-.978.985v1.751a.02.02,0,0,1-.007.013v.013a.164.164,0,0,1-.078.084.174.174,0,0,1-.078.02h-.033a.02.02,0,0,1-.012-.007c-.013,0-.027-.013-.04-.02s-.012-.006-.019-.012l-.02-.02c0-.006,0-.013-.012-.013s0-.006-.007-.012a.023.023,0,0,0-.006-.014.022.022,0,0,0-.007-.019V271.8a.979.979,0,1,0-1.958,0v1.731a.138.138,0,0,1-.071.123.073.073,0,0,1-.039.02c-.007.007-.013.007-.027.007h-.039a.173.173,0,0,1-.129-.117v-2.906a.15.15,0,0,1,.149-.148.148.148,0,0,1,.156.148v.306a1.268,1.268,0,0,1,.979-.454,1.288,1.288,0,0,1,1.135.674,1.314,1.314,0,0,1,1.141-.674,1.29,1.29,0,0,1,1.291,1.29v1.731a.153.153,0,0,1-.156.15.152.152,0,0,1-.149-.15Z",
    fill: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5657",
    "data-name": "Path 5657",
    d: "M293.894,270.657v2.867a.156.156,0,1,1-.312,0v-.473a1.483,1.483,0,0,1-1.193.629,1.591,1.591,0,0,1,0-3.178,1.475,1.475,0,0,1,1.193.623v-.468a.156.156,0,0,1,.312,0Zm-.312,1.434a1.2,1.2,0,1,0-1.193,1.277A1.241,1.241,0,0,0,293.582,272.091Z",
    fill: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5658",
    "data-name": "Path 5658",
    d: "M296.351,270.657a.17.17,0,0,1-.156.157h-.409v2.315a.249.249,0,0,0,.233.233.179.179,0,0,1,.163.162.174.174,0,0,1-.163.156.54.54,0,0,1-.557-.551v-2.315h-.4c-.155,0-.155-.079-.155-.157s0-.155.155-.155h.4v-1.181a.168.168,0,0,1,.156-.155.175.175,0,0,1,.168.155V270.5h.409A.168.168,0,0,1,296.351,270.657Z",
    fill: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5659",
    "data-name": "Path 5659",
    d: "M297.842,269.62a.159.159,0,0,1,.318,0v.15a.159.159,0,1,1-.318,0Zm0,1.037a.159.159,0,0,1,.318,0v2.867a.159.159,0,0,1-.318,0Z",
    fill: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5660",
    "data-name": "Path 5660",
    d: "M301.013,270.5a1.591,1.591,0,1,1-1.5,1.589A1.554,1.554,0,0,1,301.013,270.5Zm0,2.866a1.284,1.284,0,1,0-1.193-1.277A1.243,1.243,0,0,0,301.013,273.368Z",
    fill: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5661",
    "data-name": "Path 5661",
    d: "M305.98,271.8a.979.979,0,0,0-.979-.98,1,1,0,0,0-.985.98v1.751a.143.143,0,0,1-.034.071.137.137,0,0,1-.116.059h-.039a.168.168,0,0,1-.1-.084.025.025,0,0,1-.007-.02.021.021,0,0,0-.006-.013v-2.9a.153.153,0,1,1,.3,0v.3a1.289,1.289,0,0,1,2.276.83v1.725a.156.156,0,1,1-.312,0Z",
    fill: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5662",
    "data-name": "Path 5662",
    d: "M212.163,279.879a1.538,1.538,0,0,1,3.074-.117v.026a.147.147,0,0,1-.155.143h-2.607a1.249,1.249,0,0,0,1.232,1.218,1.191,1.191,0,0,0,1.024-.577.151.151,0,0,1,.208-.051.164.164,0,0,1,.052.22,1.513,1.513,0,0,1-1.284.72A1.564,1.564,0,0,1,212.163,279.879Zm.331-.253H214.9a1.226,1.226,0,0,0-1.193-1.031A1.24,1.24,0,0,0,212.494,279.626Z",
    fill: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5663",
    "data-name": "Path 5663",
    d: "M220.886,279.58a1,1,0,0,0-.986-.985.987.987,0,0,0-.979.985v1.751a.02.02,0,0,1-.007.013v.013a.157.157,0,0,1-.078.084.173.173,0,0,1-.077.02h-.032a.024.024,0,0,1-.014-.007c-.013,0-.026-.013-.039-.019a.031.031,0,0,1-.019-.013l-.019-.02c-.007-.005-.007-.012-.014-.012s0-.007-.006-.013a.022.022,0,0,0-.007-.014.023.023,0,0,0-.007-.019V279.58a.979.979,0,1,0-1.958,0v1.731a.141.141,0,0,1-.071.124.079.079,0,0,1-.039.019c-.007.007-.013.007-.026.007h-.038a.17.17,0,0,1-.13-.117v-2.9a.15.15,0,0,1,.149-.149.147.147,0,0,1,.155.149v.3a1.27,1.27,0,0,1,.98-.454,1.292,1.292,0,0,1,1.135.674,1.314,1.314,0,0,1,1.141-.674,1.289,1.289,0,0,1,1.29,1.29v1.731a.152.152,0,0,1-.3,0Z",
    fill: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5664",
    "data-name": "Path 5664",
    d: "M225.172,278.439v2.867a.156.156,0,0,1-.312,0v-.474a1.483,1.483,0,0,1-1.193.629,1.591,1.591,0,0,1,0-3.178,1.475,1.475,0,0,1,1.193.623v-.467a.156.156,0,1,1,.312,0Zm-.312,1.433a1.2,1.2,0,1,0-1.193,1.277A1.241,1.241,0,0,0,224.86,279.872Z",
    fill: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5665",
    "data-name": "Path 5665",
    d: "M226.526,277.4a.159.159,0,0,1,.318,0v.15a.159.159,0,1,1-.318,0Zm0,1.038a.159.159,0,0,1,.318,0v2.867a.159.159,0,0,1-.318,0Z",
    fill: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5666",
    "data-name": "Path 5666",
    d: "M228.251,277.077a.159.159,0,0,1,.318,0v4.229a.159.159,0,0,1-.318,0Z",
    fill: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5667",
    "data-name": "Path 5667",
    d: "M232.829,281.435a.112.112,0,0,1-.064-.072l-1.194-2.84a.159.159,0,0,1,.078-.2.155.155,0,0,1,.2.084l1.056,2.5.733-1.745a.169.169,0,0,1,.149-.1.172.172,0,0,1,.156.1l.733,1.745,1.05-2.5a.16.16,0,0,1,.2-.084.156.156,0,0,1,.084.2l-1.187,2.828a.2.2,0,0,1-.058.078.14.14,0,0,1-.079.032h-.032a.148.148,0,0,1-.123-.1l-.007-.006-.739-1.757-.732,1.751a.02.02,0,0,0-.007.012.153.153,0,0,1-.136.1.208.208,0,0,1-.059-.013A.038.038,0,0,1,232.829,281.435Z",
    fill: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5668",
    "data-name": "Path 5668",
    d: "M236.953,277.4a.159.159,0,0,1,.318,0v.15a.159.159,0,1,1-.318,0Zm0,1.038a.159.159,0,0,1,.318,0v2.867a.159.159,0,0,1-.318,0Z",
    fill: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5669",
    "data-name": "Path 5669",
    d: "M239.878,278.439a.168.168,0,0,1-.156.156h-.409v2.315a.251.251,0,0,0,.234.234.179.179,0,0,1,.162.162.173.173,0,0,1-.162.155.54.54,0,0,1-.558-.551V278.6h-.4c-.156,0-.156-.078-.156-.156s0-.156.156-.156h.4V277.1a.168.168,0,0,1,.155-.156.175.175,0,0,1,.169.156v1.18h.409A.168.168,0,0,1,239.878,278.439Z",
    fill: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5670",
    "data-name": "Path 5670",
    d: "M243.567,279.535a1.011,1.011,0,0,0-2.016,0v1.79c0,.013-.006.019-.006.026s-.007.019-.014.026a.147.147,0,0,1-.1.077.024.024,0,0,1-.014.007h-.032a.179.179,0,0,1-.123-.052.2.2,0,0,1-.027-.052.149.149,0,0,1-.006-.051v-4.229a.159.159,0,0,1,.318,0v1.673a1.314,1.314,0,0,1,1.006-.467,1.267,1.267,0,0,1,1.329,1.252v1.771a.16.16,0,0,1-.319,0Z",
    fill: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5671",
    "data-name": "Path 5671",
    d: "M248.509,278.283A1.591,1.591,0,1,1,247,279.872,1.555,1.555,0,0,1,248.509,278.283Zm0,2.866a1.284,1.284,0,1,0-1.194-1.277A1.243,1.243,0,0,0,248.509,281.149Z",
    fill: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5672",
    "data-name": "Path 5672",
    d: "M251.076,278.445a.154.154,0,0,1,.162-.155.152.152,0,0,1,.15.155v.7a.4.4,0,0,1,.046-.078,1.528,1.528,0,0,1,1.27-.778.153.153,0,0,1,.155.155.158.158,0,0,1-.155.156,1.148,1.148,0,0,0-.921.519,2.872,2.872,0,0,0-.383.739.105.105,0,0,0-.012.052v1.395a.152.152,0,0,1-.15.155.154.154,0,0,1-.162-.155Z",
    fill: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5673",
    "data-name": "Path 5673",
    d: "M256.3,280.845a1.511,1.511,0,0,1-1.219.616,1.59,1.59,0,0,1,0-3.178,1.515,1.515,0,0,1,1.219.623v-1.829a.159.159,0,0,1,.318,0v4.229a.159.159,0,0,1-.318,0Zm0-.914v-.1a1.266,1.266,0,1,0,0,.1Z",
    fill: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5674",
    "data-name": "Path 5674",
    d: "M257.717,279.879a1.538,1.538,0,0,1,3.074-.117v.026a.147.147,0,0,1-.156.143h-2.607a1.249,1.249,0,0,0,1.232,1.218,1.2,1.2,0,0,0,1.025-.577.15.15,0,0,1,.207-.051.164.164,0,0,1,.052.22,1.513,1.513,0,0,1-1.284.72A1.563,1.563,0,0,1,257.717,279.879Zm.331-.253h2.4a1.225,1.225,0,0,0-1.193-1.031A1.238,1.238,0,0,0,258.048,279.626Z",
    fill: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5675",
    "data-name": "Path 5675",
    d: "M261.757,278.445a.154.154,0,0,1,.162-.155.151.151,0,0,1,.149.155v.7a.52.52,0,0,1,.045-.078,1.53,1.53,0,0,1,1.272-.778.153.153,0,0,1,.155.155.158.158,0,0,1-.155.156,1.147,1.147,0,0,0-.921.519,2.84,2.84,0,0,0-.383.739.1.1,0,0,0-.013.052v1.395a.151.151,0,0,1-.149.155.154.154,0,0,1-.162-.155Z",
    fill: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5676",
    "data-name": "Path 5676",
    d: "M269.09,280.845a1.511,1.511,0,0,1-1.219.616,1.59,1.59,0,0,1,0-3.178,1.515,1.515,0,0,1,1.219.623v-1.829a.159.159,0,0,1,.318,0v4.229a.159.159,0,0,1-.318,0Zm0-.914v-.1a1.266,1.266,0,1,0,0,.1Z",
    fill: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5677",
    "data-name": "Path 5677",
    d: "M270.5,279.879a1.538,1.538,0,0,1,3.074-.117v.026a.147.147,0,0,1-.156.143h-2.607a1.251,1.251,0,0,0,1.233,1.218,1.193,1.193,0,0,0,1.024-.577.15.15,0,0,1,.207-.051.163.163,0,0,1,.052.22,1.51,1.51,0,0,1-1.283.72A1.564,1.564,0,0,1,270.5,279.879Zm.331-.253h2.406a1.227,1.227,0,0,0-1.193-1.031A1.239,1.239,0,0,0,270.835,279.626Z",
    fill: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5678",
    "data-name": "Path 5678",
    d: "M275.529,278.439a.168.168,0,0,1-.155.156h-.409v2.315a.25.25,0,0,0,.233.234.179.179,0,0,1,.162.162.173.173,0,0,1-.162.155.54.54,0,0,1-.557-.551V278.6h-.4c-.155,0-.155-.078-.155-.156s0-.156.155-.156h.4V277.1a.168.168,0,0,1,.156-.156.175.175,0,0,1,.168.156v1.18h.409A.168.168,0,0,1,275.529,278.439Z",
    fill: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5679",
    "data-name": "Path 5679",
    d: "M279.485,278.439v2.867a.155.155,0,0,1-.311,0v-.474a1.485,1.485,0,0,1-1.194.629,1.591,1.591,0,0,1,0-3.178,1.477,1.477,0,0,1,1.194.623v-.467a.155.155,0,1,1,.311,0Zm-.311,1.433a1.2,1.2,0,1,0-1.194,1.277A1.241,1.241,0,0,0,279.174,279.872Z",
    fill: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5680",
    "data-name": "Path 5680",
    d: "M280.84,277.4a.159.159,0,0,1,.318,0v.15a.159.159,0,1,1-.318,0Zm0,1.038a.159.159,0,0,1,.318,0v2.867a.159.159,0,0,1-.318,0Z",
    fill: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5681",
    "data-name": "Path 5681",
    d: "M282.564,277.077a.159.159,0,0,1,.318,0v4.229a.159.159,0,0,1-.318,0Z",
    fill: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5682",
    "data-name": "Path 5682",
    d: "M283.914,280.8a.154.154,0,0,1,.221-.02,1.7,1.7,0,0,0,.972.369.958.958,0,0,0,.6-.194.479.479,0,0,0,.24-.389.5.5,0,0,0-.226-.389,1.586,1.586,0,0,0-.675-.234l-.013-.007a1.786,1.786,0,0,1-.72-.246.661.661,0,0,1-.343-.57.789.789,0,0,1,.343-.623,1.362,1.362,0,0,1,.778-.214,1.709,1.709,0,0,1,.947.344.165.165,0,0,1,.045.221.155.155,0,0,1-.214.045,1.386,1.386,0,0,0-.778-.318.956.956,0,0,0-.6.182.474.474,0,0,0-.2.363.385.385,0,0,0,.182.318,1.605,1.605,0,0,0,.648.22h.013a2.177,2.177,0,0,1,.771.26.792.792,0,0,1,.358.648.809.809,0,0,1-.364.642,1.3,1.3,0,0,1-.791.253,1.924,1.924,0,0,1-1.173-.454A.144.144,0,0,1,283.914,280.8Z",
    fill: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5683",
    "data-name": "Path 5683",
    d: "M287.577,280.813a.324.324,0,1,1-.324.324A.32.32,0,0,1,287.577,280.813Z",
    fill: "#c7c7c7"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Character"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7581",
    "data-name": "Group 7581"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7534",
    "data-name": "Group 7534"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7527",
    "data-name": "Group 7527"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7526",
    "data-name": "Group 7526"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7525",
    "data-name": "Group 7525"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5684",
    "data-name": "Path 5684",
    d: "M140.385,349.735l2.373,14.231,16.076,86.818h2.591l-11.69-86.818-1.728-14.231Z",
    fill: "#dbdbdb"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_5685",
    "data-name": "Path 5685",
    d: "M148.008,349.735h-7.623l2.373,14.231h6.977Z",
    fill: "#a6a6a6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7530",
    "data-name": "Group 7530"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7529",
    "data-name": "Group 7529"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7528",
    "data-name": "Group 7528"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5686",
    "data-name": "Path 5686",
    d: "M89.9,450.784h2.591l16.076-86.818,2.373-14.231h-7.623l-1.728,14.231Z",
    fill: "#dbdbdb"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_5687",
    "data-name": "Path 5687",
    d: "M103.317,349.735l-1.728,14.231h6.977l2.373-14.231Z",
    fill: "#a6a6a6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7533",
    "data-name": "Group 7533"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7532",
    "data-name": "Group 7532"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7531",
    "data-name": "Group 7531"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5688",
    "data-name": "Path 5688",
    d: "M41.679,450.784H44.27l16.076-86.818,2.373-14.231H55.1l-1.728,14.231Z",
    fill: "#dbdbdb"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_5689",
    "data-name": "Path 5689",
    d: "M53.369,363.966h6.977l2.373-14.231H55.1Z",
    fill: "#a6a6a6"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5690",
    "data-name": "Path 5690",
    d: "M45.789,356.422h117.8V344.009h-44.1l-14.821-64.646H50.28Z",
    fill: "#dbdbdb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5691",
    "data-name": "Path 5691",
    d: "M45.789,356.422h6.421L56.4,279.363H50.28Z",
    fill: "#a6a6a6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7580",
    "data-name": "Group 7580"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7541",
    "data-name": "Group 7541"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7537",
    "data-name": "Group 7537"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7535",
    "data-name": "Group 7535"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5692",
    "data-name": "Path 5692",
    d: "M175.182,459.855c-2.219.757-67.529.775-69.951-.759-.29-.173-.272-8.118-.464-14.165-.294-9.24,12.078-50.389,12.078-50.389l40.525,1.974-11.3,41.473s9.333,4.135,17.036,7.755c.01.009.02.009.02.018a92,92,0,0,1,9.818,5C175.416,452.724,177.4,459.109,175.182,459.855Z",
    fill: "#eaaca7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5693",
    "data-name": "Path 5693",
    d: "M175.182,459.855c-2.219.757-67.529.775-69.951-.759-.29-.173-.423-6.071-.464-14.165,16.187,3.348,59.281,8.508,60.491,5.106.478-1.355-.57-2.879-2.13-4.275a92,92,0,0,1,9.818,5C175.416,452.724,177.4,459.109,175.182,459.855Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7536",
    "data-name": "Group 7536"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5694",
    "data-name": "Path 5694",
    d: "M78.425,330.181c7.992,7.954,42.26,24.352,44.868,30.105,2.295,5.073-13.568,59.668-13.568,59.668l39.218,7.5s23.544-63.867,17.553-83.587c-5.561-18.3-68.232-54.106-68.232-54.106H73.107S62.678,314.527,78.425,330.181Z",
    fill: "#eaaca7"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5695",
    "data-name": "Path 5695",
    d: "M158.071,332.012c-14.435,5.174-34.248,13.615-48.355,18.112-11.34-6.874-26.338-15.018-31.286-19.946C62.673,314.525,73.1,289.753,73.1,289.753H98.263S139.549,313.336,158.071,332.012Z",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7540",
    "data-name": "Group 7540"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7538",
    "data-name": "Group 7538"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5696",
    "data-name": "Path 5696",
    d: "M253.768,448.451c-2.3.452-67.022-8.3-69.217-10.142-.263-.21.4-6.073,1.443-14.1l-11.471-48.89,42.627,5.232,13.411,42a102.908,102.908,0,0,0,13.137,10.3c.008.01.018.011.017.021a92.134,92.134,0,0,1,9.058,6.273C254.957,441.416,256.067,448.01,253.768,448.451Z",
    fill: "#eaaca7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5697",
    "data-name": "Path 5697",
    d: "M253.768,448.451c-2.3.452-67.022-8.3-69.217-10.142-.263-.21.4-6.073,1.443-14.1,15.591,5.49,57.6,16.389,59.258,13.179.656-1.278-.179-2.929-1.537-4.521a92.134,92.134,0,0,1,9.058,6.273C254.957,441.416,256.067,448.01,253.768,448.451Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7539",
    "data-name": "Group 7539"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5698",
    "data-name": "Path 5698",
    d: "M226.076,408.5l-42.052,7.358L166.637,362.7c.52-18.144-2.148-24.719-12.354-27.88-17.371-5.381-59.83,14.494-79.052,1.156-15.611-10.831-3.158-46.233-3.158-46.233h45.138s5.446,6.64,6.454,10.536c0,0,55.905-4.307,68.412,11.555C208.836,333.093,226.076,408.5,226.076,408.5Z",
    fill: "#eaaca7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5699",
    "data-name": "Path 5699",
    d: "M133.9,335.109s15.936-2.792,23.562.854c6.852,3.277,9.725,7.991,9.18,26.741",
    fill: "none",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5700",
    "data-name": "Path 5700",
    d: "M72.073,289.747s-12.279,32.062-.008,43.872,26.713,9.766,61.111,2.385c0,0,17.591-22.257,28.038-26.8a61.256,61.256,0,0,1,19.975-4.883s-19.993-6.472-57.288-5.11c0,0-2.772-5.869-6.69-9.464Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7542",
    "data-name": "Group 7542"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5701",
    "data-name": "Path 5701",
    d: "M115.607,266.1a39,39,0,0,1-7.512,4.669c4.076-6.879,3.459-22.419,2.962-20.2-2.384,10.6-9.049,22.2-11.584,22.772-.017,0-.026.008-.043.008a29.248,29.248,0,0,1-18.152-3.836.066.066,0,0,1,.018-.035c5.258-7.78,5.045-23.579,4.689-22.618-3.859,10.306-11.833,16.326-13.212,16.311h-.009c-5.116-4.894-7.826-9.777-7.1-10.272,5.307-3.6,9.825-12.9,13.9-22.73v-.009C83.6,220.468,85.636,211.251,91.3,202.6c5.188-7.915,15.548-9.414,21.413-5.367C128.106,207.855,118.892,263.528,115.607,266.1Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5702",
    "data-name": "Path 5702",
    d: "M99.6,197.665c-4.266,1-7.776,4.917-10.01,8.53-2.97,4.8-4.929,10.243-7.381,15.324a106.725,106.725,0,0,1-18.59,27.326.187.187,0,0,0,.254.274c8.276-6.235,13.951-15.187,18.6-24.388,2.377-4.7,4.244-9.627,6.492-14.388a31.92,31.92,0,0,1,4.545-7.314,19.738,19.738,0,0,1,6.366-4.638A.394.394,0,0,0,99.6,197.665Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7579",
    "data-name": "Group 7579"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7550",
    "data-name": "Group 7550"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7548",
    "data-name": "Group 7548"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7543",
    "data-name": "Group 7543"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5703",
    "data-name": "Path 5703",
    d: "M157.123,214.394l-10.854,26.683a1,1,0,0,0,.7,1.6l14.274,2a2.332,2.332,0,0,0,2.186-1.193L174.286,216.8a1,1,0,0,0-.7-1.6l-14.274-2A2.33,2.33,0,0,0,157.123,214.394Z",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5704",
    "data-name": "Path 5704",
    d: "M158.819,214.617,147.965,241.3a1,1,0,0,0,.7,1.6l14.274,2a2.335,2.335,0,0,0,2.187-1.193l10.854-26.683a1,1,0,0,0-.7-1.6l-14.273-2A2.332,2.332,0,0,0,158.819,214.617Z",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5705",
    "data-name": "Path 5705",
    d: "M162.555,216.43a1.224,1.224,0,1,1-1.011-1.406A1.225,1.225,0,0,1,162.555,216.43Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5706",
    "data-name": "Path 5706",
    d: "M105.23,249.819c5.5,18.386,20.28,43.4,27.758,44.621,3.558.58,9.8,2.383,15.089-1.014,11.546-7.414,22.634-23.237,25.838-32.766,1.14-3.389-14.671-13.462-17.595-11-6.849,5.764-15.605,17.773-16.629,17.54-3.793-.865-16.925-15.6-26.08-25.956C102.5,228.665,103.038,242.492,105.23,249.819Z",
    fill: "#eaaca7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7547",
    "data-name": "Group 7547"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5707",
    "data-name": "Path 5707",
    d: "M177.023,242.732c-.736-7.336-2.051-9.107.616-15.628,1.75-4.279-.232-7.233-3.913-4.139-6.021,5.059-7.059,14.723-6.454,18.177Z",
    fill: "#eaaca7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7544",
    "data-name": "Group 7544"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5708",
    "data-name": "Path 5708",
    d: "M172.635,263.569s4.627-9.378,4.616-17.273c-.007-5.46-1.348-17.337-15.4-25.6-3.332-1.96-9.47-2.389-5.19,2.788,3.04,3.677,6.078,5.091,7.457,7.552,0,0-7.871.38-9.7,3.794a71.462,71.462,0,0,0-4.154,9.265,15.135,15.135,0,0,0,1.664.932s-1.615,3.251.193,8.475Z",
    fill: "#eaaca7"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5709",
    "data-name": "Path 5709",
    d: "M176.412,241.086c-1.885-2.153-5.956-6.65-10.566-9.17-5.12-2.8-15.738-6.811-17.766-3.01-1.486,2.787,2.433,4.676,2.433,4.676s-4.738-.734-5.53,2.078c-.722,2.562,2.4,3.841,2.4,3.841s-2.951.049-3.171,2.651c-.265,3.129,5.963,2.512,8.433,5.913C153.2,248.829,176.412,241.086,176.412,241.086Z",
    fill: "#eaaca7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7545",
    "data-name": "Group 7545"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5710",
    "data-name": "Path 5710",
    d: "M163.791,237.82a23.245,23.245,0,0,0-13.176-4.3c-.119,0-.181.095-.071.116a57.236,57.236,0,0,1,13.221,4.236C163.793,237.882,163.814,237.839,163.791,237.82Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7546",
    "data-name": "Group 7546"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5711",
    "data-name": "Path 5711",
    d: "M160.815,242.906a26.1,26.1,0,0,0-13.409-3.51c-.119.008-.175.1-.064.12a61.361,61.361,0,0,1,13.45,3.44C160.821,242.968,160.84,242.923,160.815,242.906Z",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7549",
    "data-name": "Group 7549"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5712",
    "data-name": "Path 5712",
    d: "M173.006,267.855s-18,25.321-26.537,27.287-13.266.532-16.2-.37a8.186,8.186,0,0,1-2.943-2.009c-7.264-7.024-18.741-29.742-22.921-42.17-3.133-9.342-1.461-17.122,4.88-13.587a22.836,22.836,0,0,1,5.609,4.9c10.8,12.209,23.671,24.225,24.4,23.97s9.534-10.443,9.534-10.443Z",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5713",
    "data-name": "Path 5713",
    d: "M168.822,272.331c-.842-.649-9.037-5.341-10.839-6.322s-9.131-5.063-11.072-5.92a.075.075,0,0,0-.075.129c1.746,1.2,9.127,5.34,10.943,6.377s10.022,5.5,10.989,5.865C168.849,272.49,168.879,272.375,168.822,272.331Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5714",
    "data-name": "Path 5714",
    d: "M152.535,291.52c-2.26,1.89-4.35,3.23-6.07,3.62-8.52,1.97-13.26.53-16.19-.37a7.993,7.993,0,0,1-2.95-2.01c-7.26-7.02-18.74-29.74-22.92-42.17-2.84-8.47-1.73-15.65,3.22-14.28C118.935,250.12,140.425,276.59,152.535,291.52Z",
    opacity: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7553",
    "data-name": "Group 7553"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7552",
    "data-name": "Group 7552"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5715",
    "data-name": "Path 5715",
    d: "M120.59,276.589l1.867,18.849-56.231,1.12S79.268,249.19,89.458,238.7c6.895-7.1,14.748-6.344,19.627-1.124,1.235,1.321,14.081,16.969,15.473,24.655C125.77,269.012,120.59,276.589,120.59,276.589Z",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7551",
    "data-name": "Group 7551"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5716",
    "data-name": "Path 5716",
    d: "M114.011,274.379a50.445,50.445,0,0,0-7.387.978c-1.207.269-2.393.593-3.578.942-.591.174-1.184.328-1.781.48a7.937,7.937,0,0,1-1.9.3.045.045,0,0,0,0,.089,13.555,13.555,0,0,0,1.825.023,12.915,12.915,0,0,0,1.748-.273c1.227-.261,2.44-.579,3.664-.853,2.469-.552,4.937-1.1,7.44-1.477C114.151,274.567,114.129,274.371,114.011,274.379Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5717",
    "data-name": "Path 5717",
    d: "M118.385,276.485a34.3,34.3,0,0,0-4.858-.436,22.809,22.809,0,0,0-2.437.111c-.388.036-.776.081-1.164.132-.426.055-.848.183-1.274.231-.045.005-.048.092,0,.089.4-.03.811.024,1.214.024s.811,0,1.216-.006c.812,0,1.623.009,2.435,0,1.625-.022,3.243-.023,4.867.026C118.47,276.656,118.468,276.5,118.385,276.485Z",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7563",
    "data-name": "Group 7563"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7554",
    "data-name": "Group 7554"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5718",
    "data-name": "Path 5718",
    d: "M91.107,236.117c-19.838,10.071-42.614,32.811-41.279,40.378,1.488,8.429,30-5.811,29.706-7.077-.247-1.076,5.742-10.128,14.305-23.1C102.549,233.13,96.013,233.627,91.107,236.117Z",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7562",
    "data-name": "Group 7562"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7557",
    "data-name": "Group 7557"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5719",
    "data-name": "Path 5719",
    d: "M49.828,276.495c1.742,5.886,10.518,9.829,31.684,21.833,2.929,1.661,20.211-15.856,17.175-17.79-3.825-2.436-19.195-11.064-20.4-11.553C68.136,264.861,48.647,272.5,49.828,276.495Z",
    fill: "#eaaca7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7556",
    "data-name": "Group 7556"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5720",
    "data-name": "Path 5720",
    d: "M94.5,277.991s9.11,4.656,13.14,8.584a36.152,36.152,0,0,1,8.761,14.918c1.824,6.047,2.052,21.928-2.51,22.792-4.13.782-3.544-15.463-3.544-15.463s2.135,16.661-3.011,16.689-3.392-18.792-3.392-18.792,1.81,17.168-3.5,16.357c-4.013-.613-3.385-17.748-3.385-17.748s1.453,14.768-2.7,14.315c-4.592-.5-5-16.353-5-16.353-10.368-2.929-14.106-8.564-16.288-12.89C72.538,289.353,94.5,277.991,94.5,277.991Z",
    fill: "#eaaca7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7555",
    "data-name": "Group 7555"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5721",
    "data-name": "Path 5721",
    d: "M109.98,303.012c.322,1.948.66,3.918.808,5.888s.226,3.946.189,5.921a33.738,33.738,0,0,1-.874,7.671c.709-4.54.29-11.6.143-13.571s-.195-3.94-.341-5.907C109.9,302.965,109.972,302.965,109.98,303.012Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5722",
    "data-name": "Path 5722",
    d: "M102.857,303.414c.3,2.506.695,4.982.888,7.5s.154,4.9.172,7.417c0,.193-.1.13-.112-.064-.119-2.511-.423-4.823-.571-7.333s-.2-5.025-.437-7.518C102.793,303.378,102.852,303.376,102.857,303.414Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5723",
    "data-name": "Path 5723",
    d: "M96.681,302.661a56.4,56.4,0,0,1,.48,11.573c-.006.192-.132.1-.137-.1-.087-3.85-.128-6.871-.476-11.45C96.543,302.612,96.667,302.581,96.681,302.661Z",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7561",
    "data-name": "Group 7561"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7558",
    "data-name": "Group 7558"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5724",
    "data-name": "Path 5724",
    d: "M99.043,278.494S74.67,297.058,74.41,296.963s-24.2-14.153-24.582-20.468,19.441-11.041,28.442-7.555S99.043,278.494,99.043,278.494Z",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5725",
    "data-name": "Path 5725",
    d: "M90.787,275.806c-.953.573-8.648,6.773-10.291,8.155s-8.414,6.972-9.988,8.537a.078.078,0,0,0,.1.122c1.837-1.244,8.682-6.862,10.385-8.236s9.178-7.673,9.9-8.476C90.953,275.84,90.852,275.767,90.787,275.806Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7560",
    "data-name": "Group 7560"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5726",
    "data-name": "Path 5726",
    d: "M67.431,268c2.091-.331,7.847-.812,12.517,1.531.052.026.028.093-.028.073a38.356,38.356,0,0,0-12.471-1.528C67.394,268.08,67.378,268.009,67.431,268Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7559",
    "data-name": "Group 7559"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5727",
    "data-name": "Path 5727",
    d: "M97.539,279.639l1.5-1.145A207.03,207.03,0,0,0,79.6,269.14a187.288,187.288,0,0,1,12.129-19.619",
    fill: "none",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5728",
    "data-name": "Path 5728",
    d: "M86.845,256.728c.155-.064,4.066-4.012,4.066-4.012",
    fill: "none",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5729",
    "data-name": "Path 5729",
    d: "M67.357,292.6s4.174,2.684,5.613,3.526",
    fill: "none",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7578",
    "data-name": "Group 7578"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7564",
    "data-name": "Group 7564"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5730",
    "data-name": "Path 5730",
    d: "M97.983,235.887c.266,1.48,3.771,8.2,8.284,8.046,2.32-.078,2.367-8.208,2.367-8.208l.115-.6,1.6-8.366-11.391-6.745S97.908,235.464,97.983,235.887Z",
    fill: "#eaaca7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5731",
    "data-name": "Path 5731",
    d: "M98.573,225.781a17.114,17.114,0,0,0,10.179,9.347l1.6-8.367-11.4-6.747S98.774,222.652,98.573,225.781Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7577",
    "data-name": "Group 7577"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5732",
    "data-name": "Path 5732",
    d: "M122.089,213.925c1.307,14.892-7.465,17.357-10.676,17.635-2.916.253-12.875.743-15.714-13.935s3.672-19.993,10.309-20.924S120.782,199.032,122.089,213.925Z",
    fill: "#eaaca7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7571",
    "data-name": "Group 7571"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5733",
    "data-name": "Path 5733",
    d: "M119.527,210.587a10.014,10.014,0,0,1-1.016-.183,1.669,1.669,0,0,1-1-.386.531.531,0,0,1-.018-.649,1.32,1.32,0,0,1,1.291-.345,1.939,1.939,0,0,1,1.235.649A.568.568,0,0,1,119.527,210.587Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5734",
    "data-name": "Path 5734",
    d: "M109.967,210.9a9.831,9.831,0,0,0,1-.242,1.672,1.672,0,0,0,.977-.442.532.532,0,0,0-.02-.649,1.317,1.317,0,0,0-1.308-.271,1.939,1.939,0,0,0-1.2.72A.568.568,0,0,0,109.967,210.9Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7566",
    "data-name": "Group 7566"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7565",
    "data-name": "Group 7565"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5735",
    "data-name": "Path 5735",
    d: "M112.066,214.617c-.01-.039-.077.052-.073.094.085,1.014.012,2.191-.89,2.577-.028.012-.022.062.012.056C112.229,217.127,112.31,215.564,112.066,214.617Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5736",
    "data-name": "Path 5736",
    d: "M111.1,213.6c-1.641-.038-1.6,3.248-.077,3.283C112.522,216.921,112.479,213.635,111.1,213.6Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5737",
    "data-name": "Path 5737",
    d: "M110.46,213.785c-.284.189-.561.521-.907.56-.4.045-.706-.295-.972-.622-.028-.034-.056-.005-.056.038,0,.63.25,1.273.926,1.357.617.078,1.051-.485,1.2-1.12C110.679,213.88,110.575,213.708,110.46,213.785Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7568",
    "data-name": "Group 7568"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7567",
    "data-name": "Group 7567"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5738",
    "data-name": "Path 5738",
    d: "M117.665,214.369c.007-.039.08.048.079.089-.027,1.018.114,2.189,1.036,2.522.029.01.026.061-.008.057C117.648,216.885,117.476,215.329,117.665,214.369Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5739",
    "data-name": "Path 5739",
    d: "M118.568,213.3c1.636-.134,1.783,3.149.267,3.273C117.343,216.7,117.2,213.413,118.568,213.3Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5740",
    "data-name": "Path 5740",
    d: "M119.262,213.486c.267.163.538.467.849.474.36.007.61-.359.824-.71.022-.036.049-.01.052.033.046.627-.133,1.29-.73,1.437-.545.135-.973-.386-1.15-1C119.074,213.6,119.154,213.421,119.262,213.486Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5741",
    "data-name": "Path 5741",
    d: "M111.772,222.637c.188.284.357.656.711.764a2.7,2.7,0,0,0,1.124-.019.035.035,0,0,1,.032.06,1.373,1.373,0,0,1-1.38.268,1.083,1.083,0,0,1-.592-1.048C111.664,222.6,111.745,222.6,111.772,222.637Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7569",
    "data-name": "Group 7569"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5742",
    "data-name": "Path 5742",
    d: "M116.317,218.931s.248,1.515.266,2.232A3.857,3.857,0,0,1,112.8,220.1c-.059-.062.038-.145.1-.1a5.14,5.14,0,0,0,3.134.814c.046-.2-.511-2.58-.4-2.591a6.272,6.272,0,0,1,1.638.328c-.426-3.17-1.356-6.246-1.732-9.408a.1.1,0,0,1,.186-.052,51.743,51.743,0,0,1,2.3,10.055C118.1,219.548,116.607,219.046,116.317,218.931Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7570",
    "data-name": "Group 7570"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5743",
    "data-name": "Path 5743",
    d: "M115.6,221.111a3.7,3.7,0,0,1-1.475,1.159,1.662,1.662,0,0,1-1.012.07c-.733-.187-.756-.859-.626-1.435a3.992,3.992,0,0,1,.322-.882A4.8,4.8,0,0,0,115.6,221.111Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5744",
    "data-name": "Path 5744",
    d: "M114.127,222.27a1.662,1.662,0,0,1-1.012.07c-.733-.187-.756-.859-.626-1.435A1.722,1.722,0,0,1,114.127,222.27Z",
    fill: "#ff9bbc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7573",
    "data-name": "Group 7573"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7572",
    "data-name": "Group 7572"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5745",
    "data-name": "Path 5745",
    d: "M96.535,217.21c2.785.4,3.607-5.981,3.607-5.981s11.923-1.817,13.093-11.481a16.376,16.376,0,0,0,8.115,9.1s-.238-10.619-8.618-12.822c0,0-10.378-3.975-16.386,4.213S94.666,216.942,96.535,217.21Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5746",
    "data-name": "Path 5746",
    d: "M113.288,199.033a10.529,10.529,0,0,1-.6,4.41,10.975,10.975,0,0,1-2.309,3.872,9.367,9.367,0,0,1-.816.79l-.419.383c-.149.116-.305.224-.459.332-.313.213-.616.44-.934.64-.332.179-.667.351-1,.519-.168.083-.333.173-.5.249l-.527.194-1.052.384c-.721.188-1.451.338-2.175.477.688-.287,1.391-.5,2.063-.788l.993-.462.494-.23c.159-.087.311-.188.466-.282.308-.191.616-.379.929-.559.3-.205.576-.434.864-.649l.43-.324.391-.371a9.07,9.07,0,0,0,.762-.757,12.574,12.574,0,0,0,2.326-3.6,13.138,13.138,0,0,0,.7-2.059A12.645,12.645,0,0,0,113.288,199.033Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7576",
    "data-name": "Group 7576"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7574",
    "data-name": "Group 7574"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5747",
    "data-name": "Path 5747",
    d: "M98.31,216.681s-3.268-4.663-5.384-3.5.344,7.927,2.831,8.85a2.528,2.528,0,0,0,3.386-1.362Z",
    fill: "#eaaca7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5748",
    "data-name": "Path 5748",
    d: "M93.679,215.1a.035.035,0,0,0-.013.067,6.39,6.39,0,0,1,3.308,3.995,1.4,1.4,0,0,0-2.089-.38c-.046.033,0,.1.047.093a1.556,1.556,0,0,1,1.712.541,7.49,7.49,0,0,1,.821,1.384c.082.155.363.072.3-.108l-.014-.04C97.8,218.434,96.066,215.326,93.679,215.1Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7575",
    "data-name": "Group 7575"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5749",
    "data-name": "Path 5749",
    d: "M96.039,221.479a.642.642,0,1,0,.451-.788A.642.642,0,0,0,96.039,221.479Z",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5750",
    "data-name": "Path 5750",
    d: "M96.365,221.39a.3.3,0,1,0,.214-.373A.3.3,0,0,0,96.365,221.39Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5751",
    "data-name": "Path 5751",
    d: "M94.916,220.7a.453.453,0,1,0,.318-.557A.453.453,0,0,0,94.916,220.7Z",
    fill: "#455a64"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_5752",
    "data-name": "Path 5752",
    d: "M90.338,236.514s7.317,11.425,15.589,11.267c6.568-.124,7.058-7.889,7.058-7.889a16.078,16.078,0,0,0-12.129-6.374A17.913,17.913,0,0,0,90.338,236.514Z",
    fill: "#eaaca7"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Speech_Bubble",
    "data-name": "Speech Bubble"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7583",
    "data-name": "Group 7583"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7582",
    "data-name": "Group 7582"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5753",
    "data-name": "Path 5753",
    d: "M169.995,181.341a21.735,21.735,0,0,1-36.323,13.751l-10.876,1.6,5.441-9.4a21.742,21.742,0,1,1,41.758-5.944Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5754",
    "data-name": "Path 5754",
    d: "M169.995,181.341a21.9,21.9,0,0,1-4.388,11.02,19.653,19.653,0,0,1-4.265,4.211,21.441,21.441,0,0,1-5.244,2.92,21.676,21.676,0,0,1-5.853,1.4,21.308,21.308,0,0,1-3.021.057,19,19,0,0,1-3.008-.313,21.927,21.927,0,0,1-10.756-5.31l.257.079-10.865,1.668-.789.121.4-.7,5.41-9.421-.025.372a21.986,21.986,0,0,1,1.339-19.377,22.23,22.23,0,0,1,6.809-7.25,22.117,22.117,0,0,1,19.109-2.573,22.2,22.2,0,0,1,8.384,5.141A21.869,21.869,0,0,1,169.995,181.341Zm0,0a21.506,21.506,0,0,0-24.654-23.528,21.372,21.372,0,0,0-8.979,3.547,22.4,22.4,0,0,0-6.505,7.1,21.463,21.463,0,0,0-2.759,9.2,21.714,21.714,0,0,0,1.53,9.471l.079.194-.1.178-5.474,9.384-.389-.574,10.886-1.524.151-.022.107.1a21.408,21.408,0,0,0,10.41,5.362,18.748,18.748,0,0,0,2.949.359,21.1,21.1,0,0,0,2.975,0,21.449,21.449,0,0,0,5.807-1.278,20.253,20.253,0,0,0,5.244-2.827,24.363,24.363,0,0,0,2.295-1.916,24.073,24.073,0,0,0,1.978-2.246A21.852,21.852,0,0,0,169.995,181.341Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5755",
    "data-name": "Path 5755",
    d: "M145.827,191.478l-9.286-9.4,3.12-3.082,5.424,5.49,11.269-17.667,3.7,2.358Z",
    fill: "#ff725e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Plant"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7592",
    "data-name": "Group 7592"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7589",
    "data-name": "Group 7589"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7584",
    "data-name": "Group 7584"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5756",
    "data-name": "Path 5756",
    d: "M415.178,339s10.01-35.93,18.005-48.132,22.895-25.606,22.895-25.606S455.728,320.657,415.178,339Z",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5757",
    "data-name": "Path 5757",
    d: "M415.895,338.385a171.956,171.956,0,0,0,9.125-17.408,121.694,121.694,0,0,1,4.972-18.894c.042-.115.2-.052.176.063-1.328,5.677-2.873,11.3-4.277,16.962,4.041-8.744,7.882-17.6,12.7-25.866a55.221,55.221,0,0,1,4.64-11.5c.053-.1.227-.049.176.063a73.682,73.682,0,0,0-3.122,8.624,86.038,86.038,0,0,1,7.605-10.506c.175-.2.526.022.353.243-6.435,8.213-10.877,17.555-15.107,27.015a143.729,143.729,0,0,0,12.56-15.7.054.054,0,0,1,.089.061,129.06,129.06,0,0,1-13.451,17.437c-3.081,6.93-6.11,13.89-9.783,20.483,7.34-6.2,12.985-14.231,18.574-21.977a.168.168,0,0,1,.276.19c-5.591,8.5-11.377,16.5-19.42,22.8a89.225,89.225,0,0,1-5.375,8.395A.429.429,0,0,1,415.895,338.385Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7586",
    "data-name": "Group 7586"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5758",
    "data-name": "Path 5758",
    d: "M412.075,342.236s17.993-33.13,12.766-65.25-10.823-43.558-10.823-43.558S385.735,283.387,412.075,342.236Z",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7585",
    "data-name": "Group 7585"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5759",
    "data-name": "Path 5759",
    d: "M404.689,290.153a156.947,156.947,0,0,0,6.946,26.751c.05-11.789.275-23.577.59-35.362a91.19,91.19,0,0,1-3.4-21.953c-.008-.218.317-.2.335.006a125.163,125.163,0,0,0,3.152,18.89q.409-14.586.949-29.166a.127.127,0,0,1,.254,0c-.014,15.189-.006,30.381-.1,45.571a121.747,121.747,0,0,0,5.187-18.046.054.054,0,0,1,.105.016c-.541,7.094-2.7,13.953-5.311,20.536-.07,9.71-.175,19.42-.391,29.127,3.043-10.322,6.3-20.32,7.175-31.228a.114.114,0,0,1,.228,0c-.239,12.029-3.339,24.24-7.307,35.552a.655.655,0,0,1-.2.285q-.137,5.322-.311,10.644a.4.4,0,0,1-.79-.014q-.21-10.889-.177-21.78a97.561,97.561,0,0,1-7.094-29.82C404.524,290.082,404.676,290.063,404.689,290.153Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5760",
    "data-name": "Path 5760",
    d: "M405.923,285.029a61.9,61.9,0,0,1,1.256,8.753c.005.1-.147.113-.171.02a61.95,61.95,0,0,1-1.481-8.726C405.5,284.851,405.879,284.809,405.923,285.029Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5761",
    "data-name": "Path 5761",
    d: "M416.443,260.812c.017-.1.169-.068.17.026a22.463,22.463,0,0,1-.9,6.037c-.044.16-.275.086-.244-.072C415.86,264.811,416.1,262.808,416.443,260.812Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7588",
    "data-name": "Group 7588"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5762",
    "data-name": "Path 5762",
    d: "M405.514,344.772s.734-34.582-9.187-51.772-26.376-25.948-26.376-25.948S376.586,328.012,405.514,344.772Z",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7587",
    "data-name": "Group 7587"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5763",
    "data-name": "Path 5763",
    d: "M387.434,315.2a128.474,128.474,0,0,0,13.425,17.017q-2.97-10.606-6.867-20.856c-5.561-4.877-11.077-9.93-14.49-16.6a.094.094,0,0,1,.163-.1c3.668,5.91,8.574,10.639,13.737,15.187a267.626,267.626,0,0,0-13.81-30.073.22.22,0,0,1,.379-.222,164.249,164.249,0,0,1,8.659,15.784c-.93-3.7-1.673-7.477-2.626-11.146a.082.082,0,0,1,.158-.044,62.718,62.718,0,0,1,4.074,14.668,176.166,176.166,0,0,1,8.733,23.665c-.255-5.184-.58-10.346-1.115-15.516-.01-.1.155-.12.173-.023a83.958,83.958,0,0,1,1.5,17.419q2.145,7.731,3.6,15.623c.026.141-.182.2-.217.06-.538-2.2-1.124-4.387-1.721-6.566-.038-.016-.078-.01-.113-.045-5.321-5.33-10.375-11.407-13.7-18.2A.031.031,0,0,1,387.434,315.2Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5764",
    "data-name": "Path 5764",
    d: "M375.939,287.058c1.106,1.194,2.119,2.449,3.187,3.679a28.235,28.235,0,0,1,2.857,3.336.057.057,0,0,1-.077.077,16.849,16.849,0,0,1-3.3-3.256,27.905,27.905,0,0,1-2.825-3.714A.1.1,0,0,1,375.939,287.058Z",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7591",
    "data-name": "Group 7591"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7590",
    "data-name": "Group 7590"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5765",
    "data-name": "Path 5765",
    d: "M434.987,340.549l-1.251,16.382-3.769,49.518H397.1l-3.769-49.518-1.25-16.382h42.9Z",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5766",
    "data-name": "Path 5766",
    d: "M434.987,340.549l-1.251,16.382h-40.4l-1.25-16.382h42.9Z",
    fill: "#37474f"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_423",
    "data-name": "Rectangle 423",
    width: 48.742,
    height: 12.559,
    transform: "translate(437.906 345.07) rotate(180)",
    fill: "#455a64"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurchesorder);
export default __webpack_public_path__ + "static/media/purchesorder.afd489525b340ac99d7d28e7ac634cfb.svg";
export { ForwardRef as ReactComponent };